// removed by extract-text-webpack-plugin
module.exports = {"PurchaseCard":"PurchaseCard__PurchaseCard__2J6AG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tracker/PurchaseCard/PurchaseCard.css
// module id = 62
// module chunks = 0